import AlertBanner from './AlertBanner';
export { AlertBanner as default };
